<div class="warning-container" *ngIf="!isHidden && !isDismissed">
  <div class="message-row">
    <ion-icon
      class="alert-icon"
      name="alert-circle-outline"
      color="warning"
      aria-hidden="true"
    ></ion-icon>
    <span class="message-text">
      Larger files may consume additional mobile data. Consider using Wi-Fi to
      avoid extra fees.
    </span>
    <ion-icon
      class="close-circle-outline"
      name="close-circle-outline"
      (click)="dismiss()"
      role="button"
      aria-label="Dismiss warning"
    ></ion-icon>
  </div>
  <div class="checkbox-row">
    <ion-checkbox
      [(ngModel)]="dontShowAgain"
      (ionChange)="onCheckboxChange($event)"
      labelPlacement="end"
      mode="md"
      aria-label="Don't show this message again"
    ></ion-checkbox>
    <ion-label class="checkbox-label">Don't show this message again.</ion-label>
  </div>
</div>
